import React, {useState} from "react";
import {Box} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useGridApiRef} from "@mui/x-data-grid-pro";
import emptyTransactions from "../../../assets/lists/empty_transactions.svg";
import {TEmailTemplate} from "../../../interfaces/email";
import ListSnackbar, {TAlert} from "../../../patterns/list/listSnackbar";
import {getArchivedEmailTemplates} from "../../../services/AdminService";
import {actionColumn, columnDefinition, ColumnType} from "../../../patterns/list/listUtils";
import ListArchivedEmailTemplatesActions from "./listArchivedEmailTemplatesActions";
import List from "../../../patterns/list/list";
import {RequestFilter, RequestFilterOperator, RequestOrder} from "../../../common/methods/ApiService";

export default function ListArchivedEmailTemplate(props: {operationId: string, setReloadParent: (reload: boolean) => void}): JSX.Element {
  const {operationId, setReloadParent} = props;
  const {t} = useTranslation();
  const apiRef = useGridApiRef();

  const [reload, setReload] = useState(false);
  const [alerts, setAlerts] = useState<TAlert[]>([]);

  const columns = [
    columnDefinition(t, "email_templates.archived", "name", 200, ColumnType.STRING),
    columnDefinition(t, "email_templates.archived", "subject", 250, ColumnType.STRING),
    columnDefinition(t, "email_templates.archived", "deletedAt", 250, ColumnType.DATE_TIME),
    actionColumn(params => ListArchivedEmailTemplatesActions(params, setReload, setAlerts, setReloadParent))
  ]

  const loadArchivedTemplates = (page: number, maxItems: number, search: string, order: RequestOrder, filters: RequestFilter[]): Promise<{totalItems: number, items: TEmailTemplate[]}> => {
    return getArchivedEmailTemplates(page, maxItems, search, order, [
      ...filters,
      {field: 'operation', items: [{operator: RequestFilterOperator.EQUALS, value: operationId, isDate: false, isDatePrecise: false}]}
    ]);
  }

  return (
    <Box sx={{height: "82.5vh", p: 7}}>
      <ListSnackbar alerts={alerts} setAlerts={setAlerts}/>
      <List
        enableSelection={false}
        translationPrefix="email_templates.archived"  
        columns={columns}
        apiRef={apiRef}
        loadRows={loadArchivedTemplates}
        height="75vh"
        reload={reload}
        setReload={setReload}
        emptyListIcon={emptyTransactions}
        sx={{width: "100%"}}
        enableToolbarSearch={true}
      />
    </Box>
  )
}
